import { createSlice } from '@reduxjs/toolkit';

const formsSlice = createSlice({
  name: "sideForms",
  initialState: {
    formType: null,
    formProps: {},
  },
  reducers: {
    showForm: (state, action) => {
      state.formType = action.payload.formType;
      state.formProps = action.payload.formProps;
    },
    hideForm: (state) => {
      state.formType = null;
      state.formProps = {};
    },
  }
});

const { actions, reducer } = formsSlice;

// Accept either a full element object (gallery click) or a bare numeric id
// (post-create-redirect). The historic call sites pass an element, but the
// upload flow only has the new id at hand and would otherwise hit
// `undefined.model.ID` and toast a misleading "Fehler beim erstellen".
export const openElementForm = (elementOrId) => {
  const id = elementOrId && typeof elementOrId === 'object'
    ? elementOrId?.model?.ID
    : elementOrId;
  return actions.showForm({formType: 'ELEMENT_FORM', formProps: { id }})
}

// openVariantGroupForm — opens the dedicated side form for editing a variant
// group. The gallery dispatches this when a variant-group tile is clicked.
export const openVariantGroupForm = (groupId) => {
  return actions.showForm({formType: 'VARIANT_GROUP_FORM', formProps: { id: groupId }})
}

export const openLocationForm = (id) => {
  return actions.showForm({formType: 'LOCATION_FORM', formProps: { id: id }})
}

export const openDeviceForm = (id) => {
  return actions.showForm({formType: 'MICAST_FORM', formProps: { id: id }})
}

export const openUserForm = (id) => {
  return actions.showForm({formType: 'USER_FORM', formProps: { id: id }})
}
export const openOrganisationForm = (id) => {
  return actions.showForm({formType: 'ORGANISATION_FORM', formProps: { id: id }})
}

export const openElementUploadForm = (element) => {
  return actions.showForm({formType: 'ELEMENT_FORM', formProps: { isNew: true, multipleUploads: true, element: element }})
}

export const openShowItemForm = (item, orientation, onSave) => {
  return actions.showForm({formType: 'STREAM_ITEM_FORM', formProps: { item, orientation, onSave }})
}


export const { showForm, hideForm } = actions;
export default reducer;
